import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-586dc0ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-left" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "header-center"
}
const _hoisted_4 = { class: "header-right" }
const _hoisted_5 = { class: "header-right-segment header-right-segment--search cm-ui-mr5" }
const _hoisted_6 = {
  key: 0,
  class: "header-right-segment"
}
const _hoisted_7 = { class: "header-right-segment" }
const _hoisted_8 = { class: "header-right-segment" }
const _hoisted_9 = { class: "header-right-segment" }
const _hoisted_10 = {
  key: 1,
  class: "header-right-segment"
}
const _hoisted_11 = { class: "btn_tool btn_tool-small" }
const _hoisted_12 = {
  key: 2,
  class: "header-right-segment"
}
const _hoisted_13 = {
  style: {"cursor":"pointer"},
  class: "btn_tool btn_tool-small"
}
const _hoisted_14 = { class: "header-right-segment" }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 1,
  class: "icon-vipbadge"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["title"]
const _hoisted_25 = {
  key: 0,
  class: "page-header"
}
const _hoisted_26 = { class: "page-header-text" }
const _hoisted_27 = { class: "page-header-title" }
const _hoisted_28 = {
  key: 0,
  class: "page-header-describe"
}
const _hoisted_29 = {
  key: 0,
  class: "router-view-wrap router-view-transition-wrap"
}

import '@/assets/nav-icon/iconfont.css'
import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { GroupService } from './_components/group-tree/group.service'
import CentralControl from './_components/central-control/central-control.vue'

import { Team, TeamInfo } from '@/services/team'

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { GroupRefreshManage } from '@/services/group'
import { ResizeService } from '@/services/resize.service'
import { getTreeNode } from '@/utils/tool'
import CustomerService from '@/views/_components/customer-service/customer-service.vue'
import MpQr from '@/views/_components/mp-qr/mp-qr.vue'
import AideDrawer from '@/views/_components/aide/aide-drawer.vue'
import AideFixed from '@/views/_components/aide/aide-fixed.vue'
import NotifyPopup from '@/views/dashboard/_notify-popup/notify-popup.vue'
import { ServicePermissionService } from '@/services/service-permission.service'
import Footer from '@/views/_components/footer/footer.vue'
import { HIDE_FUNC } from '@/common/const/hide-function-config'
import { DEFAULT_ACTIVE, LAST_NAV_KEY, MENU_LIST, MenuItem, SidebarActive, isPathNotExists } from '@/router/nav-menu'
import { DashboardService } from '@/views/dashboard/dashboard.service'
import { IS_PRIVATE } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { logoDashboardHeaderSrc } from '@/services/brand-custom.service'
import { useRolePermStore } from '@/services/role-perm.service'
import { storeToRefs } from 'pinia'
import UnreadCount from '@/views/_components/unread-count/unread-count.vue'
import { useDashboardPageFixStore } from '@/stores/dashboard-page-fix.store'
import NavSearch from './_components/nav-search/nav-search.vue'
import DashboardNavThemeToggle from './_components/dashboard-nav-theme-toggle.vue'
import DashboardThemeModeToggle from './_components/dashboard-theme-mode-toggle.vue'
import LangToggle from './_components/lang-toggle.vue'
import HeaderTopMenu from './_components/header-top-menu/header-top-menu.vue'
import {
  getDashboardNavTheme,
  onDashboardNavThemeChange,
} from '@/utils/dashboard-nav-theme'
import type { DashboardNavTheme } from '@/utils/dashboard-nav-theme'
import { useSubscribeDetailsDrawerStore } from '@/stores/subscribe-details-drawer.store'
import { useAideDrawerStore } from '@/stores/aide-drawer.store'
import { resolveAiAssistantAccessState } from '@/views/dashboard/service/service-subscribe/ai-assistant-detail/ai-assistant.service'
import SubscribeDetails from '@/views/dashboard/service/subscribe-details/subscribe-details.vue'
import { notifyPopupService } from '@/common/basis/root-injector'
import { PopupKey } from '@/views/dashboard/_notify-popup/notify-popup.service'
import { isEditableShortcutTarget, isPlainShiftChord } from '@/utils/keyboard-shortcut'

const SIDEBAR_LAYOUT_TRANSITION_MS = 250

export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const isRouterAlive = ref<boolean>(true)
const activePath = ref('')
const sidebarCollapse = ref(false)
/** 侧边栏折叠动画结束后再触发，与 `.left-side` 的 transition 对齐 */
let sidebarLayoutResizeTimer: ReturnType<typeof setTimeout> | null = null
let rightsMapSubscription: ReturnType<ServicePermissionService['rightsMap']['subscribe']> | null = null
const injector = useReflectiveInjector([GroupService, GroupRefreshManage, {
  provide: DashboardService,
  useValue: new DashboardService(isRouterAlive)
}])

const resizeService = injector.get(ResizeService)
const servicePermissionService = injector.get(ServicePermissionService)
const aideRightsMapVersion = ref(0)
const aiAssistantAccessState = computed(() => {
  void aideRightsMapVersion.value
  return resolveAiAssistantAccessState(servicePermissionService.rightsMapData)
})
const rolePermStore = useRolePermStore()
const isRolePermLoading = storeToRefs(rolePermStore).isLoading
const dashboardPageFixStore = useDashboardPageFixStore()
const aideDrawerStore = useAideDrawerStore()

const team = injector.get(Team)
const teamInfo = reactive<Partial<TeamInfo>>({})
const currentMenuItem = ref({} as MenuItem)
const visibleMenuList = ref<MenuItem[]>([])

const navTheme = ref<DashboardNavTheme>(getDashboardNavTheme())
/** 天空蓝：顶栏一级菜单 + 浅色侧栏；深蓝：侧栏全量 + 深蓝侧栏 */
const isSkyTheme = computed(() => navTheme.value === 'sky')

function findFirstMenuPath(items: MenuItem[] | undefined): string | undefined {
  if (!items?.length) return undefined
  for (const item of items) {
    if (item.path) return item.path
    const nested = findFirstMenuPath(item.children)
    if (nested) return nested
  }
  return undefined
}

function isPathUnderMenu(path: string, root: MenuItem): boolean {
  if (root.path === path) return true
  if (!root.children?.length) return false
  return root.children.some(child => isPathUnderMenu(path, child))
}

const activeTopMenu = computed(() => {
  const path = activePath.value || route.path
  const active = visibleMenuList.value.find(item => {
    return item.path === path ||
      item.children?.find(v => v.path === path) ||
      item.children?.find(v => v.children?.find(k => k.path === path))
  })
  return active || {} as MenuItem
})

const activeTopMenuLabel = computed(() => activeTopMenu.value?.label ?? '')

const sidebarMenuItems = computed(() => {
  if (!isSkyTheme.value) return visibleMenuList.value
  return activeTopMenu.value?.children ?? []
})

/** 根据当前路由找出需要展开的 submenu 的 label 列表 */
const defaultOpeneds = computed(() => {
  const path = activePath.value
  if (!path) return []
  const opened: string[] = []
  function findPath(items: MenuItem[], parents: string[]) {
    if (!items?.length) return false
    for (const item of items) {
      if (item.path === path) return true
      if (item.children?.length) {
        const next = [...parents, item.label]
        if (findPath(item.children, next)) {
          opened.push(item.label)
          return true
        }
      }
    }
    return false
  }
  findPath(sidebarMenuItems.value, [])
  return opened.reverse()
})

function handleTopMenuClick(item: MenuItem) {
  if (item.path) {
    router.push(item.path)
    return
  }
  if (!item.children?.length) return
  if (!isPathUnderMenu(route.path, item)) {
    const firstPath = findFirstMenuPath(item.children)
    if (firstPath) router.push(firstPath)
  }
}

function ensureSkyNavSidebarRoute() {
  if (!isSkyTheme.value) return
  const top = activeTopMenu.value
  if (!top?.label) return
  if (top.path && route.path === top.path) return
  const items = sidebarMenuItems.value
  if (!items.length) return
  const matched = getTreeNode({
    tree: { children: items },
    field: 'path',
    value: route.path,
    childrenField: 'children',
  })
  if (matched) return
  /**
   * 隐藏分组（label 为空的「没有自己导航选中的页面」）里的页面同样不在当前顶部菜单的侧栏中，
   * 但路径本身合法（如订阅市场内页 /dashboard/ai-assistant-detail、策略编辑页等），不能兜底跳转，
   * 否则天空蓝主题下刚进页面就会被弹回该顶部菜单首项。
   */
  if (!isPathNotExists({ currentPath: route.path, isExclude: (menu) => menu.isHide })) return
  if (top.children?.length) {
    const firstPath = findFirstMenuPath(top.children)
    if (firstPath && firstPath !== route.path) router.push(firstPath)
  }
}

team.currentTeam.subscribe(info => {
  Object.assign(teamInfo, info)

  // if (!teamInfo.team_id) {
  //   router.replace('/team')
  // }
  notifyPopupService.popupToReady(PopupKey.welcome)
})

/**
 * 已选团队且 AI 助手订阅生效才挂 iframe。
 * 登出、未选团队、未购买、已过期：卸载 iframe。
 */
function syncAideBoot() {
  const teamId = Number(teamInfo.team_id)
  const state = teamId
    ? resolveAiAssistantAccessState(servicePermissionService.rightsMapData)
    : 'not_purchased'
  if (!teamId || state !== 'active') {
    aideDrawerStore.release()
    return
  }
  aideDrawerStore.prepare(teamId)
  aideDrawerStore.setBootEnabled(true)
}

function getFilterMenu(rolePermMap) {
  const menuList = JSON.parse(JSON.stringify(MENU_LIST)).filter(v => v.label)
  const deepFilter = (menuList: MenuItem[]) => {
    return menuList?.filter((item: MenuItem) => {
      item.children = deepFilter(item.children)
      const isEmpty = !item.path && !item.children?.length
      const noRolePerm = item.rolePermKey && !rolePermMap[item.rolePermKey]
      // 日文专版：服务级权限 hasPermission=false 时隐藏菜单
      let noServicePerm = false
      if (IS_JP_ONLY_BUILD && item.servicePermissionKey) {
        noServicePerm = !servicePermissionService.getHasPermission(item.servicePermissionKey)
      }
      return !(isEmpty || noRolePerm || noServicePerm)
    })
  }
  return deepFilter(menuList) || []
}

function saveLastNav() {
  activePath.value && localStorage.setItem(LAST_NAV_KEY, activePath.value)
}

window.addEventListener('pagehide', saveLastNav)
let aideBootSyncEnabled = false
servicePermissionService.refreshCurrentTeamPermission().finally(() => {
  aideBootSyncEnabled = true
  syncAideBoot()
})
servicePermissionService.refreshAllPermission()
const aideRightsSubscription = servicePermissionService.rightsMap.subscribe(() => {
  aideRightsMapVersion.value += 1
  if (!aideBootSyncEnabled) return
  syncAideBoot()
})

function handleSidebarToggleKeydown(e: KeyboardEvent) {
  if (!isPlainShiftChord(e)) return
  if (e.key.toLowerCase() !== 'b') return
  if (isEditableShortcutTarget(e.target)) return
  e.preventDefault()
  sidebarCollapse.value = !sidebarCollapse.value
}

watch(sidebarCollapse, () => {
  if (sidebarLayoutResizeTimer != null) {
    clearTimeout(sidebarLayoutResizeTimer)
  }
  sidebarLayoutResizeTimer = setTimeout(() => {
    sidebarLayoutResizeTimer = null
    window.dispatchEvent(new Event('resize'))
  }, SIDEBAR_LAYOUT_TRANSITION_MS)
})

let unsubscribeNavTheme: (() => void) | undefined

onMounted(() => {
  team.refreshTeamList()
  window.addEventListener('keydown', handleSidebarToggleKeydown, true)
  unsubscribeNavTheme = onDashboardNavThemeChange((theme) => {
    navTheme.value = theme
    nextTick(() => ensureSkyNavSidebarRoute())
  })
  ensureSkyNavSidebarRoute()
  // 日文专版：服务权限异步加载完成后刷新菜单可见性
  if (IS_JP_ONLY_BUILD) {
    rightsMapSubscription = servicePermissionService.rightsMap.subscribe(() => {
      visibleMenuList.value = getFilterMenu(rolePermStore.cmRolePermMapBe)
    })
  }
})

onUnmounted(() => {
  aideDrawerStore.release()
  window.removeEventListener('keydown', handleSidebarToggleKeydown, true)
  unsubscribeNavTheme?.()
  rightsMapSubscription?.unsubscribe()
  aideRightsSubscription.unsubscribe()
  if (sidebarLayoutResizeTimer != null) {
    clearTimeout(sidebarLayoutResizeTimer)
    sidebarLayoutResizeTimer = null
  }
})

watch(navTheme, () => {
  nextTick(() => ensureSkyNavSidebarRoute())
})

watch(route, () => {
  currentMenuItem.value = getTreeNode({
    tree: { children: MENU_LIST },
    field: 'path',
    value: route.path,
    childrenField: 'children'
  }) || {} as MenuItem

  // 保存上一个导航高亮路径
  saveLastNav()

  const { sidebarActive } = currentMenuItem.value
  if (sidebarActive === SidebarActive.inherit) {
    activePath.value = localStorage.getItem(LAST_NAV_KEY) || DEFAULT_ACTIVE
  } else if (sidebarActive === SidebarActive.none) {
    activePath.value = ''
  } else if (sidebarActive) {
    activePath.value = sidebarActive as string
  } else {
    activePath.value = route.path
  }
  ensureSkyNavSidebarRoute()
}, { immediate: true })

// 直接监听 ref 本身
watch(rolePermStore.cmRolePermMapBe, (rolePermMap) => {
  visibleMenuList.value = getFilterMenu(rolePermMap)
}, { deep: true, immediate: true })

const { t } = useI18n()
const pageHeaderDescribe = computed(() => {
  const item = currentMenuItem.value
  if (item?.describeKey) return t(item.describeKey)
  return (item as { describe?: string })?.describe ?? ''
})

/** 一级菜单直接绑定 path 的页面（如响应中心、审批中心）原先因 activeTopMenu.path 有值而不显示顶栏；与当前路由一致时应显示标题与 describe */
const showPageHeader = computed(() => {
  if (currentMenuItem.value?.noBreadcrumb) return false
  const top = activeTopMenu.value
  if (!top?.path) return true
  return top.path === route.path
})

const subscribeDetailsDrawerStore = useSubscribeDetailsDrawerStore()
const {
  visible: subscribeDetailsDrawerVisible,
  query: subscribeDetailsDrawerQuery,
  instanceKey: subscribeDetailsDrawerInstanceKey,
  renewAll: subscribeDetailsDrawerRenewAll,
} = storeToRefs(subscribeDetailsDrawerStore)
const subscribeDetailsDrawerModel = computed({
  get: () => subscribeDetailsDrawerVisible.value,
  set: (v: boolean) => {
    if (!v) subscribeDetailsDrawerStore.close()
  },
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_submenu = _resolveComponent("el-submenu")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, {
    class: _normalizeClass(["main-container", { 'is-sky-nav-layout': isSkyTheme.value }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, {
        height: "50px",
        class: _normalizeClass(["header", { 'is-sky-nav-layout': isSkyTheme.value }])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, { to: "/dashboard/overview" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "logo-img",
                  src: _unref(logoDashboardHeaderSrc),
                  style: _normalizeStyle(!_unref(IS_JP_ONLY_BUILD) && { height: '30px' }),
                  alt: "logo"
                }, null, 12, _hoisted_2)
              ]),
              _: 1
            })
          ]),
          (isSkyTheme.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(HeaderTopMenu, {
                  "menu-list": visibleMenuList.value,
                  "active-label": activeTopMenuLabel.value,
                  onSelect: handleTopMenuClick
                }, null, 8, ["menu-list", "active-label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(NavSearch, { "menu-list": visibleMenuList.value }, null, 8, ["menu-list"])
            ]),
            (!_unref(IS_JP_ONLY_BUILD))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(DashboardNavThemeToggle)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(DashboardThemeModeToggle)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(LangToggle)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(UnreadCount)
            ]),
            (!_unref(HIDE_FUNC).customerService && !_unref(IS_JP_ONLY_BUILD))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_el_popover, {
                    trigger: "click",
                    width: 254,
                    offset: 4,
                    "show-arrow": false
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, [
                        _createVNode(_component_CmSvgIcon, {
                          name: "assets/icons/custom-service",
                          size: 21,
                          monochrome: ""
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(CustomerService)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (!_unref(IS_PRIVATE) && !_unref(IS_JP_ONLY_BUILD))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_el_popover, {
                    trigger: "click",
                    width: 214,
                    offset: 10,
                    "show-arrow": false
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_CmSvgIcon, {
                          name: "assets/icons/mp-qr",
                          size: 21,
                          monochrome: ""
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(MpQr)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(CentralControl)
            ])
          ])
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_el_container, { class: "main" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(["left-side", { 'is-collapse': sidebarCollapse.value, 'is-sky-sidebar': isSkyTheme.value }])
          }, [
            _createVNode(_component_el_menu, {
              router: "",
              size: "small",
              "default-active": activePath.value,
              class: "left-menu",
              collapse: sidebarCollapse.value,
              "menu-trigger": "click",
              "collapse-transition": false,
              "default-openeds": defaultOpeneds.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarMenuItems.value, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.children?.length)
                      ? (_openBlock(), _createBlock(_component_el_submenu, {
                          key: 0,
                          index: item.label
                        }, {
                          title: _withCtx(() => [
                            (item.icon)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + item.icon])
                                }, null, 2))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: "menu-title",
                              title: item.label ? _ctx.$t(item.label) : ''
                            }, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 9, _hoisted_15)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subIndex) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: subIndex }, [
                                (subItem.children?.length)
                                  ? (_openBlock(), _createBlock(_component_el_submenu, {
                                      key: 0,
                                      index: subItem.label
                                    }, {
                                      title: _withCtx(() => [
                                        false
                                          ? (_openBlock(), _createElementBlock("i", {
                                              key: 0,
                                              class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + subItem.icon])
                                            }, null, 2))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", {
                                          class: "menu-title",
                                          title: subItem.label ? _ctx.$t(subItem.label) : ''
                                        }, _toDisplayString(subItem.label ?
                      _ctx.$t(subItem.label) : ''), 9, _hoisted_16)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.children, (third, thirdIndex) => {
                                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                                            class: "left-menu-third",
                                            key: thirdIndex,
                                            index: third.path
                                          }, {
                                            default: _withCtx(() => [
                                              false
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + third.icon])
                                                  }, null, 2))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", {
                                                class: "menu-title",
                                                title: third.label ? _ctx.$t(third.label) : ''
                                              }, _toDisplayString(third.label ?
                      _ctx.$t(third.label) : ''), 9, _hoisted_17),
                                              (third.vipOnly && !_unref(HIDE_FUNC).service__subscribe)
                                                ? (_openBlock(), _createBlock(_component_CmSvgIcon, {
                                                    key: 1,
                                                    name: "assets/icons/vip-badge",
                                                    size: 16,
                                                    class: "icon-vipbadge"
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["index"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["index"]))
                                  : (sidebarCollapse.value)
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 1,
                                        content: _ctx.$t(subItem.label),
                                        placement: "right",
                                        effect: "dark"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_menu_item, {
                                            class: "left-menu-second",
                                            index: subItem.path
                                          }, {
                                            default: _withCtx(() => [
                                              false
                                                ? (_openBlock(), _createElementBlock("i", {
                                                    key: 0,
                                                    class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + subItem.icon])
                                                  }, null, 2))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", {
                                                class: "menu-title",
                                                title: subItem.label ? _ctx.$t(subItem.label) : ''
                                              }, _toDisplayString(subItem.label ?
                      _ctx.$t(subItem.label)
                      : ''), 9, _hoisted_18),
                                              (subItem.vipOnly && !_unref(HIDE_FUNC).service__subscribe)
                                                ? (_openBlock(), _createBlock(_component_CmSvgIcon, {
                                                    key: 1,
                                                    name: "assets/icons/vip-badge",
                                                    size: 16,
                                                    class: "icon-vipbadge"
                                                  }))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["index"])
                                        ]),
                                        _: 2
                                      }, 1032, ["content"]))
                                    : (_openBlock(), _createBlock(_component_el_menu_item, {
                                        key: 2,
                                        class: "left-menu-second",
                                        index: subItem.path
                                      }, {
                                        default: _withCtx(() => [
                                          false
                                            ? (_openBlock(), _createElementBlock("i", {
                                                key: 0,
                                                class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + subItem.icon])
                                              }, null, 2))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", {
                                            class: "menu-title",
                                            title: subItem.label ? _ctx.$t(subItem.label) : ''
                                          }, _toDisplayString(subItem.label ?
                    _ctx.$t(subItem.label) :
                    ''), 9, _hoisted_19),
                                          (subItem.vipOnly && !_unref(HIDE_FUNC).service__subscribe)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"]))
                              ], 64))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      : (sidebarCollapse.value)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 1,
                            content: _ctx.$t(item.label),
                            placement: "right",
                            effect: "dark"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_menu_item, {
                                index: item.path
                              }, {
                                default: _withCtx(() => [
                                  (item.icon)
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + item.icon])
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    class: "menu-title",
                                    title: item.label ? _ctx.$t(item.label) : ''
                                  }, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 9, _hoisted_21),
                                  (item.vipOnly && !_unref(HIDE_FUNC).service__subscribe)
                                    ? (_openBlock(), _createBlock(_component_CmSvgIcon, {
                                        key: 1,
                                        name: "assets/icons/vip-badge",
                                        size: 16,
                                        class: "icon-vipbadge"
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["index"])
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 2,
                            index: item.path
                          }, {
                            default: _withCtx(() => [
                              (item.icon)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: _normalizeClass(["nav-menu-icon iconfont", 'team-admin-nav-icon-' + item.icon])
                                  }, null, 2))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: "menu-title",
                                title: item.label ? _ctx.$t(item.label) : ''
                              }, _toDisplayString(item.label ? _ctx.$t(item.label) : ''), 9, _hoisted_22),
                              (item.vipOnly && !_unref(HIDE_FUNC).service__subscribe)
                                ? (_openBlock(), _createBlock(_component_CmSvgIcon, {
                                    key: 1,
                                    name: "assets/icons/vip-badge",
                                    size: 16,
                                    class: "icon-vipbadge"
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["default-active", "collapse", "default-openeds"]),
            _createElementVNode("div", {
              class: _normalizeClass(["sidebar-fold", { 'is-collapse': sidebarCollapse.value }]),
              title: sidebarCollapse.value ? _ctx.$t('nav.sidebarFoldTitleCollapsed') : _ctx.$t('nav.sidebarFoldTitleExpanded'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarCollapse.value = !sidebarCollapse.value))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["fold-arrow", sidebarCollapse.value ? 'fold-arrow-expand' : 'fold-arrow-collapse'])
              }, null, 2),
              (!sidebarCollapse.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "sidebar-fold-label",
                    title: _ctx.$t('nav.collapseSidebar')
                  }, _toDisplayString(_ctx.$t('nav.collapseSidebar')), 9, _hoisted_24))
                : _createCommentVNode("", true)
            ], 10, _hoisted_23)
          ], 2), [
            [_vShow, !isSkyTheme.value || sidebarMenuItems.value.length]
          ]),
          _createVNode(_component_el_container, {
            class: _normalizeClass(["container", { 'no-scroll': _unref(dashboardPageFixStore).isPageFix || currentMenuItem.value.pageFix }]),
            style: {"display":"flex","flex-direction":"column"}
          }, {
            default: _withCtx(() => [
              (showPageHeader.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(currentMenuItem.value.label ? _ctx.$t(currentMenuItem.value.label) : ''), 1),
                      (pageHeaderDescribe.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(pageHeaderDescribe.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_main, {
                class: _normalizeClass(["main-cntr", { 'has-breadcrumb': showPageHeader.value, 'is-page-fix': _unref(dashboardPageFixStore).isPageFix || currentMenuItem.value.pageFix }])
              }, {
                default: _withCtx(() => [
                  (isRouterAlive.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_Transition, {
                          mode: "out-in",
                          "enter-active-class": "router-view-enter-active animate__faster animate__animated animate__fadeIn",
                          "leave-active-class": "router-view-leave-active animate__faster animate__animated animate__fadeOut"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("div", {
                              class: "router-view-transition-wrap",
                              key: _unref(route).fullPath
                            }, [
                              _createVNode(_component_router_view)
                            ]))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(Footer)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }),
      (aiAssistantAccessState.value === 'active')
        ? (_openBlock(), _createBlock(AideFixed, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(AideDrawer),
      _createVNode(NotifyPopup),
      _createVNode(_component_el_drawer, {
        modelValue: subscribeDetailsDrawerModel.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subscribeDetailsDrawerModel).value = $event)),
        size: "80%",
        "destroy-on-close": "",
        direction: "rtl",
        title: _ctx.$t('menu.subscribeDetails'),
        class: "subscribe-details-dashboard-drawer"
      }, {
        default: _withCtx(() => [
          (_unref(subscribeDetailsDrawerVisible))
            ? (_openBlock(), _createBlock(SubscribeDetails, {
                key: _unref(subscribeDetailsDrawerInstanceKey),
                "drawer-mode": "",
                "initial-route-query": _unref(subscribeDetailsDrawerQuery),
                "renew-all": _unref(subscribeDetailsDrawerRenewAll),
                onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(subscribeDetailsDrawerStore).close()))
              }, null, 8, ["initial-route-query", "renew-all"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }, 8, ["class"])), [
    [_vShow, !_unref(isRolePermLoading)]
  ])
}
}

})